module.exports = __webpack_public_path__ + "fonts/fontagon-icons.bc9f409.woff2";